import customer from './customer';
import site from './site';
import castType from './castType';
import payment from './payment';
import salesOrder from './salesOrder';
import invoice from './invoice';
import paymentMode from './paymentMode';
import creditNotes from './creditNotes';
import debitNotes from './debitNotes';
import report from './report';
import quotation from './quotation';
import dashboard from './dashboard';
import dpk from './dpk';
import plants from './plants';
import item from './item';
import reports from './reports';

export default {
    namespaced: true,
    state: {
        routePrefix: '/sales'
    },
    mutations: {},
    actions: {},
    modules: {
        customer,
        site,
        castType,
        payment,
        salesOrder,
        invoice,
        paymentMode,
        creditNotes,
        debitNotes,
        report,
        quotation,
        dashboard,
        dpk,
        plants,
        item,
        reports
    }
}